import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  membershipPlanList: []
};

const membershipPlanReducerSlice = createSlice({
  name: 'membershipPlan',
  initialState,
  reducers: {
    updateMembershipPlans(state, action) {
      return {
        ...state,
        membershipPlanList: [...action.payload]
      };
    },
    updatemembershipPlan(state, action) {
      return {
        ...state,
        membershipPlanList: state.membershipPlanList.map((membershipPlan) => {
          if (membershipPlan._id === action.payload.id) {
            return action.data;
          }
          return membershipPlan;
        })
      };
    }
  }
});

export const membershipPlanReducerAction = membershipPlanReducerSlice.actions;
export const membershipPlanReducers = membershipPlanReducerSlice.reducer;
